<template>
  <div>
    <div class="content">
      <div class="title">招聘信息</div>
      <div class="list">
        <div class="item" v-for="item in recruitmentList" :key="item.recruitment_id">
          <div v-html="item.content"></div>
          <div class="time">工作地址:{{ item.address }}</div>
          <div class="time">发布时间:{{ item.createtime }}</div>
        </div>
      </div>
      <div class="Notice">
        <div class="ico">
          <div class="tb"><img src="../assets/images/Recruitment.png"></div>
          <h3>应聘<br>须知</h3>
        </div>
        <div class="text">1.应聘方式<br>
          在线投递 / 电子邮件： {{ companyInfo.email }}  / 联系电话：{{ companyInfo.mobile }}<br>
          2.面试材料<br>
          请携带个人简历、学历证明材料、有关荣誉、技术职称证明材料、身份证复印件、设计作品等相关资料。<br>
          3.交通指南<br>
          联系地址：{{ companyInfo.address }}<br>
        </div>
      </div>
    </div>
  </div>

</template>

<script>
import { get, post, put, del } from '../utils/http'
export default {
  name: 'recruitment',
  data() {
    return {
      recruitmentList: [],
      companyInfo:JSON.parse(localStorage.getItem('companyInfo'))
    }
  },
  mounted() {
    this.getList()
  },
  methods: {
    getList() {
      get('/index/getRecruitList').then(res => {
        console.log(res)
        if (res.code == 1) {
          this.recruitmentList = res.data.data
        }
      })
    }
  }

}
</script>

<style scoped>
.content {
  width: 1200px;
  margin: 0 auto;
  min-height: 100vh;
}

.recruitmentList {
  width: 100%;
  display: flex;
}

.title {
  margin-bottom: 20px;
  padding: 20px;
  background: var(--bg-card);
  border-radius: 10px;
  box-shadow: var(--shadow-md);
  color: var(--text-primary);
  font-size: 24px;
  font-weight: 700;
}

.list {
  width: 100%;
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  grid-gap: 20px;
}

.item {
  box-sizing: border-box;
  width: 100%;
  margin-bottom: 20px;
  padding: 20px;
  border: 1px solid var(--border-color);
  border-radius: 5px;
  box-shadow: var(--shadow-md);
  position: relative;
  background: var(--bg-card);
  color: var(--text-secondary);
}

.item .time {
  color: var(--text-tertiary);
  margin-top: 10px;
  font-size: 14px;
}

.Notice {
  overflow: hidden;
  margin-top: 58px;
  border: 1px solid var(--border-color);
}

.Notice .ico {
  float: left;
  width: 234px;
  background: var(--bg-tertiary);
  height: 209px;
}

.Notice .ico .tb {
  margin-top: 40px;
  display: flex;
  justify-content: center;
}

.Notice .ico h3 {
  font-size: 26px;
  color: #fff;
  margin-top: 10px;
  text-align: center;
}

.Notice .text {
  background: var(--bg-card);
  height: 159px;
  text-align: left;
  padding: 25px 40px 25px 40px;
  float: right;
  width: 884px;
  line-height: 24px;
  color: var(--text-secondary);
}
</style>